<ac-info-box small>
  <span class="paragraph-m mr-1">{{ 'NOTIFICATION.NO_DATA.' + specific | translate }}</span>
  <span class="paragraph-m">{{ 'NOTIFICATION.ANY_QUESTION' | translate }}</span>
  <a acSecondaryLink action [href]="'mailto:' + _mailSig()" target="_blank" rel="noreferrer noopener">
    {{ 'GENERAL.CONTACT_US' | translate }}
  </a>
</ac-info-box>
